<template>
  <v-container>
      <v-row>
          <v-col>
              <h1 class="text-h2">Facturation</h1>
              <h2 id="global" class="text-h4">Principes de base</h2>
              <p>Les factures sont générée automatiquement à partir d'une commande, il lui est attribué un numéro de facture unique et incrémenté dépendant de la "Locations" séléctionnée</p>
              <p>Il ne peut y avoir qu'une seule facture par commande</p>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h3 id="sent" class="text-h4">Envoi d'une facture au client</h3>
              <p>L'envoi de la facture a été automatisée, mais il est possible d'envoyer la facture manuellement au client, afin de représenter ces deux possibilités, lorsqu'une commande est validée, deux boutons apparaisent</p>
              <ul>
                  <li>SEND TO CLIENT<br>
                  Il s'agit du bouton qui va envoyé la facture au client directement depuis le middleware</li>
                  <li>MARK AS SENT<br>
                    Cette action permet de dire au middleware que la facture a été transmise au client par un autre moyen
                  </li>
              </ul>
              <p>Ces deux actions aboutissent au même point, la facture passera du status "NEW" au status "OPEN" et cette facture rentrera dans les rapports de comptabilité comme étant dûe</p>
              <p>Si jamais des dépôts avant validation on été effectué pour le montant total de la facture, ces dépôts seront transformé en "PAYOUT" et si la totalité de la facture est payée elle passera directement en status "CLOSE"</p>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h3 id="payout" class="text-h4">Dépot et paiement</h3>
              <p>Lorsque la commande a été validée il est possible d'ajouté un dépôt ou un paiement pour cette commande</p>
              <p>La différence vient du moment où vous faite l'entrée d'argent</p>
              <ul>
                  <li>si vous saisissez le paiement avant d'avoir envoyé la facture au client (avant que la facture ne soit en status "OPEN") il n'est possible que de faire des dépôts, avec le bouton "ADD DEPOSIT"</li>
                  <li>si vous saissiez le paiement après avoir envoyé la facture il n'est possible que de faire des paiements, avec le bouton "ADD PAYOUT"</li>
              </ul>
              <p>Un dépôt peut-être partiel, il sera transformer en paiement dès que vous aurez envoyé la facture au client</p>
              <p>Vous pouvez voir la liste des paiements et dépôts effectué en cliquant sur le bouton "PAYOUT LIST"</p>
              <p>Il y a cinq solutions de paiement acceptées :</p>
              <ul>
                <li><strong>CASH</strong> : Si le client paie directement en cash</li>
                <li><strong>VIREMENT</strong> : Si le client paie par virement bancaire</li>
                <li><strong>CLIENT's CREDIT</strong> : En cas d'annulation de facture déjà payée par le client une note de crédit sera créée et vous pourrez l'utiliser à ce endroit</li>
                <li><strong>CYBERSOURCE</strong> : Il est possible de débiter la carte de crédit du client directement depuis CYBERSOURCE</li>
                <li><strong>TPE Xperience</strong> : Il s'agit du terminal de paiement de Xperience</li>
              </ul>
            
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h3 id="cancel" class="text-h4">Annulation d'une facture</h3>
              <p>Il est possible d'annuler une facture en cliquant sur le bouton "CANCEL" de la commande, cela aura pour effet d'annuler la commande et la facture</p>
              <p>Si un dépot ou un paiement a déjà été effectué, une note de crédit du même montant sera créée pour ce client</p>
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
export default { 

}
</script>

<style>

</style>